import React from 'react'
import { useTranslation } from 'react-i18next'
 
const HeroSlide = ({ slide }) => {

  const { i18n } = useTranslation()
  const lang = i18n.language

  return (
    <div className="hero-slider-slide" style={{backgroundImage: `url(${slide.acf.bg})`}}>
      <div className="content">
        <div className="content-wrapper">
          <div className="title">{slide.acf.names[`name_${lang}`]}</div>
          <div className="desc">{slide.acf.contents[`content_${lang}`]}</div>
        </div>
        <img src={slide.acf.img} alt="" className="img"/>
      </div>
    </div>
  )
}

export default HeroSlide